import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { Button } from '@frontierag/frontier-ui-library';
import { ChevronLeft as ChevronLeftIcon } from '@frontierag/frontier-ui-library/icons';

export default function BackToHomepage() {
  const { t } = useTranslation();
  return (
    <Button
      sx={{ px: 2 }}
      startIcon={<ChevronLeftIcon />}
      component={Link}
      to="/"
      data-testid="back-to-homepage"
    >
      {t('buttons.backToHomepage')}
    </Button>
  );
}
